import { numberDigits } from "@/utils";

/**
 * 智能数字格式化函数
 * 根据数值大小自动选择合适的显示格式
 * @param value 要格式化的数值
 * @returns 包含显示值和完整值的对象
 */
export function formatSmartNumber(value: number | string): { display: string; fullValue: string } {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  
  if (isNaN(num)) {
    return { display: '0.00', fullValue: '0.00' };
  }
  
  const fullValue = numberDigits(num, 4);
  
  if (num < 1000) {
    // 小于 1,000：原样显示
    return { display: numberDigits(num, 2), fullValue };
  } else if (num < 1000000) {
    // 大于等于 1,000，小于 1,000,000：显示为 x.xxK（千）
    const kValue = num / 1000;
    return { display: `${numberDigits(kValue, 2)}K`, fullValue };
  } else if (num < 1000000000) {
    // 大于等于 1,000,000，小于 1,000,000,000：显示为 x.xxM（百万）
    const mValue = num / 1000000;
    return { display: `${numberDigits(mValue, 2)}M`, fullValue };
  } else {
    // 大于等于 1,000,000,000：显示为 x.xxB（十亿）
    const bValue = num / 1000000000;
    return { display: `${numberDigits(bValue, 2)}B`, fullValue };
  }
}